var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"m8 9.061-2.47 2.47-1.06-1.062L6.94 8.001 4.47 5.53 5.53 4.47 8 6.94l2.47-2.47 1.06 1.061-2.47 2.47 2.47 2.47-1.06 1.061z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }